import React from "react";

import {
  WEEKLY_COLUMN_WIDTH,
  DIRECT_LABOR_STATIC_COLUMNS,
  getStaticColumnsTotalWidth,
} from "./weeklyEACColumns";
import { WEEKLY_SUMMARY_ROWS } from "./weeklyEACSummaryRows";
import { formatCellValue } from "./weeklyEACFormat";

// Column width equals Direct Labor's 3 week sub-columns combined, so each week here lines up
// under that same week's block in the Direct Labor table above. A leading empty column (padded
// to Direct Labor's Account-through-Apply-Burden static columns width) comes first, since Direct
// Labor's week columns don't start until after those.
export default function WeeklyEACSummaryWeeklyValues({
  weeklyTotals,
  type,
  isEdit,
  onCreditOverCeilingChange,
}) {
  const staticColumnsWidth = getStaticColumnsTotalWidth(type);
  const visibleStaticColumns = DIRECT_LABOR_STATIC_COLUMNS.filter(
    (column) => column.hideForType !== type,
  );
  const visibleRows = WEEKLY_SUMMARY_ROWS.filter((row) => row.hideForType !== type);

  return (
    <table className="secondTableFin weeklyEac" cellPadding={0} cellSpacing={0}>
      <tbody>
        {visibleRows.map((row) => (
          <tr key={row.key} className="totalRow">
            {staticColumnsWidth > 0 && (
              <td
                colSpan={visibleStaticColumns.length}
                style={{ minWidth: staticColumnsWidth }}
              />
            )}
            {weeklyTotals.map((week, index) => {
              const editableCreditOverCeiling =
                isEdit &&
                row.key === "creditOverCeilingRate" &&
                week.type === "Forecast";
              return (
                <td
                  key={week.weekStartDate}
                  style={{
                    minWidth: WEEKLY_COLUMN_WIDTH,
                    maxWidth: WEEKLY_COLUMN_WIDTH,
                    borderLeft: "1px solid #ccc",
                    paddingLeft: "4px",
                    ...(index === weeklyTotals.length - 1
                      ? { borderRight: "1px solid #ccc" }
                      : {}),
                  }}
                  title={formatCellValue(week[row.key] ?? 0, row.format)}
                >
                  {editableCreditOverCeiling ? (
                    <input
                      type="number"
                      value={week.creditOverCeilingRate ?? ""}
                      style={{ width: "80px" }}
                      onChange={(e) =>
                        onCreditOverCeilingChange(
                          week.weekStartDate,
                          e.target.value,
                        )
                      }
                    />
                  ) : (
                    formatCellValue(week[row.key] ?? 0, row.format)
                  )}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
